/**
 * Barra de filtros da Instrumentação (M6) — fiel ao protótipo V8: rótulo "Filtrar:"
 * + três selects (Estrutura / Tipo / Seção). As opções de Tipo vêm de `TIPO_OPTS`,
 * derivado do catálogo de tipos monitorados (MSE dobra em MS).
 * Componente controlado — só emite `onChange`; o recorte fica no domínio.
 */
import { ALL_DAMS } from '@/domain/instrumentos/dam-filter';
import { TIPO_OPTS, type InstrumentFilters } from '../domain/chart-data';
import type { DamOption } from '@/hooks/useDams';

interface FilterBarProps {
  dams: DamOption[];
  /** Seções disponíveis na estrutura filtrada (únicas, ordenadas). */
  sections: string[];
  filters: InstrumentFilters;
  onChange: (next: InstrumentFilters) => void;
  className?: string;
}

const selectCls =
  'text-[11px] bg-jf-surface text-white border border-jf-border rounded-md px-2 py-1 ' +
  'pr-6 cursor-pointer focus:outline-none focus:border-jf-yellow';

export default function FilterBar({ dams, sections, filters, onChange, className = '' }: FilterBarProps) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-[11px] font-bold uppercase tracking-wide text-jf-dim">Filtrar:</span>

      <select
        aria-label="Filtrar por estrutura"
        className={selectCls}
        value={filters.dam}
        // Trocar de estrutura zera a seção (evita seção órfã, como no V8).
        onChange={(e) => onChange({ ...filters, dam: e.target.value, sec: '' })}
      >
        <option value={ALL_DAMS}>Estrutura: Todas</option>
        {dams.map((d) => (
          <option key={d.id} value={d.id}>Estrutura: {d.code}</option>
        ))}
      </select>

      <select
        aria-label="Filtrar por tipo"
        className={selectCls}
        value={filters.tipo}
        onChange={(e) => onChange({ ...filters, tipo: e.target.value })}
      >
        <option value="">Tipo: todos</option>
        {TIPO_OPTS.map((t) => (
          <option key={t} value={t}>Tipo: {t}</option>
        ))}
      </select>

      <select
        aria-label="Filtrar por seção"
        className={selectCls}
        value={filters.sec}
        onChange={(e) => onChange({ ...filters, sec: e.target.value })}
        disabled={sections.length === 0}
      >
        <option value="">Seção: todas</option>
        {sections.map((s) => (
          <option key={s} value={s}>Seção: {s}</option>
        ))}
      </select>
    </div>
  );
}
